const getOpeningMessage = ({ time, lang }) =>
    lang === 'es' ? `Abre a las ${time}` : `${time}etan zabaltzen da`

export default getOpeningMessage;